// extracted by mini-css-extract-plugin
module.exports = {"tableWrapper":"styles_tableWrapper__2WIyQ","col":"styles_col__3WVv3","fulfillmentStatus":"styles_fulfillmentStatus__1NQ-G","emailCol":"styles_emailCol__3IDSv"};